import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TimerService } from "../services/timer.service";

@Component({
    selector: "nx-delete-dialog",
    templateUrl: "./confirm-dialog.component.html",
    styleUrls: ["./confirm-dialog.component.scss"],
    standalone: false
})
export class ConfirmDialogComponent {
  timerService = inject(TimerService);
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<ConfirmDialogComponent>>(MatDialogRef);


  public confirmAction() {
    this.dialogRef.close(true);
  }

  public denyAction() {
    this.dialogRef.close(false);
  }
}
